<template>
  <div v-if="mail && mail.to" class="w-full border border-blue-500 rounded p-2">
    <button class="w-fit block mb-2 py-0 text-sm ml-auto mr-3 text-indigo-800 hover:text-indigo-500" @click="openMailMst=true">メールアドレスマスタ編集</button>
    <!-- メールアドレス -->
    <div class="mb-3">
      <div class="flex justify-between">
        <div class="text-xs font-bold mt-auto">送信先
          <span class="-top-0.5 ml-1 text-red-500"> * </span>
        </div>
        <PrimaryButton
          text="送信先追加"
          @click="mailAdd()"
          class="h-7 bg-blue-50 text-blue-900 border-blue-900 m-1"
        >
          <Icon
            iconName="PlusCircle" 
            slot="before"
            class="w-4 h-4 mr-0.5"
          />
        </PrimaryButton>
      </div>
      <div v-for="(m, i) in mail.to" :key="i">
        <div class="flex">
          <WmsSuggestInput
            :name="'mail' + i" 
            :required="true"
            :selectionItems="mailList"
            :displayField="['company']"
            v-model="mail.to[i]"
            class="w-full"
            :error="!mail.to[i]"
            errorMessage="メールアドレス必須"
            @selected="mailSelected($event, mail.to, i)"
          >
          </WmsSuggestInput>
          <div v-tooltip="'メールアドレスをマスタに保存'" class="mx-1 cursor-pointer" @click="saveMail(mail.to[i])">
            <Icon
              iconName="Save" 
              class="w-6 h-10 text-indigo-600"
            />
          </div>
          <div class="m-auto ml-2">
            <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="mailDelete(i)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- CC -->
    <div class="mb-3">
      <div class="flex justify-between">
        <div class="text-xs font-bold mt-auto">CC</div>
        <PrimaryButton
          text="CC追加"
          @click="ccAdd()"
          class="h-7 bg-blue-50 text-blue-900 border-blue-900 m-1"
        >
          <Icon
            iconName="PlusCircle" 
            slot="before"
            class="w-4 h-4 mr-0.5"
          />
        </PrimaryButton>
      </div>
      <div v-for="(m, j) in mail.cc" :key="j">
        <div class="flex">
          <WmsSuggestInput
            :name="'cc' + j" 
            :required="true"
            :selectionItems="ccList"
            :displayField="['name', 'mail']"
            v-model="mail.cc[j]"
            class="w-full"
            @selected="mailSelected($event, mail.cc, j)"
          >
          </WmsSuggestInput>
          <div class="m-auto ml-2">
            <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="ccDelete(j)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- BCC -->
    <div class="mb-3">
      <div class="flex justify-between">
        <div class="text-xs font-bold mt-auto">BCC</div>
        <PrimaryButton
          text="BCC追加"
          @click="bccAdd()"
          class="h-7 bg-blue-50 text-blue-900 border-blue-900 m-1"
        >
          <Icon
            iconName="PlusCircle" 
            slot="before"
            class="w-4 h-4 mr-0.5"
          />
        </PrimaryButton>
      </div>
      <div v-for="(m, j) in mail.bcc" :key="j">
        <div class="flex">
          <WmsSuggestInput
            :name="'bcc' + j" 
            :required="true"
            :selectionItems="ccList"
            :displayField="['name', 'mail']"
            v-model="mail.bcc[j]"
            class="w-full"
            @selected="mailSelected($event, mail.bcc, j)"
          >
          </WmsSuggestInput>
          <div class="m-auto ml-2">
            <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="bccDelete(j)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 件名 -->
    <div class="mb-3">
      <WmsTextInput
        name="subject" 
        caption="件名" 
        :required="true"
        :error="mail.subject==''"
        errorMessage="必須"
        v-model="mail.subject"
        @change="reload++"
      />
    </div>

    <!-- 本文 -->
    <div class="text-xs font-bold text-blue-700 mt-5 mb-2">---以下はメール本文です（記入している項目のみメールで送信します）---</div>
    <div class="mb-3 rounded p-2">
      <div>
        <p class="text-xs font-bold text-gray-600 mb-1">受付者</p>
        <input
          autocomplete="off"
          type="text"
          v-model="mail.user"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">受付日</p>
        <input
          autocomplete="off"
          type="date"
          v-model="mail.date"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">受付時間</p>
        <input
          autocomplete="off"
          type="text"
          v-model="mail.time"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">社名（物件名）</p>
        <input
          autocomplete="off"
          type="text"
          v-model="mail.client1"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          @change="$emit('setDentatsuSubject')"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">支店</p>
        <input
          autocomplete="off"
          type="text"
          v-model="mail.client2"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">氏名<span class="text-blue-700 pl-16">※「従業員名」と連動</span></p>
        <input
          autocomplete="off"
          type="text"
          v-model="requestPost.employeeName"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">連絡先<span class="text-blue-700 pl-50px">※「電話番号」と連動</span></p>
        <input
          autocomplete="off"
          type="text"
          v-model="requestPost.telephoneNumber"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
      <div class="mt-3">
        <p class="text-xs font-bold text-gray-600 mb-1">依頼内容<span class="text-blue-700 pl-10">※「お問い合わせ内容」と連動</span></p>
        <textarea
          v-model="requestPost.inquiry_title"
          rows="3"
          class="w-full border border-gray-200 rounded focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
      </div>
    </div>

    <div v-if="requestPost.mailResult&&requestPost.mailResult.length" class="text-xs whitespace-pre-line">
      <p>{{ requestPost.mailResult.join('\r\n') }}</p>
    </div>

    <!-- 送信 -->
    <div v-if="!referenceMode" class="w-fit my-1 mr-1 ml-auto">
      <PrimaryButton
        v-if="!sending"
        text="送信"
        @click="sendMail()"
        class="px-10"
      >
      </PrimaryButton>
      <div v-else class="text-3xl font-bold text-blue-600 animate-pulse">
        送信中・・・
      </div>
    </div>
    <div v-else class="w-fit my-1 mr-1 ml-auto text-xl font-bold text-blue-500">
      メインタスク完了のため、送信不可
    </div>
    <div class="hidden">{{reload}}</div>
    
    <!-- メールマスタ -->
    <DentatsuMailMstModal 
      v-model="openMailMst"
      :open="openMailMst"
      @close="closeMailMstModal"
    />
    
    <!-- 編集画面 -->
    <DentatsuMailMstEditModal 
      v-model="editModalShow"
      :open="editModalShow"
      :newData="newData"
      @close="closeEditModal"
    />
  </div>
</template>
<script>
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import PrimaryButton from '@components/PrimaryButton.vue'
import DentatsuMailMstModal from '../components/DentatsuMailMstModal.vue'
import DentatsuMailMstEditModal from '../components/DentatsuMailMstEditModal.vue'
import Icon from '@components/Icon.vue'
import * as dialogs from '@libs/dialogs'
import * as backend from '@libs/backend'
import * as moment from 'moment'
import * as utils from '@libs/utils'
  
  export default {
    components: {
      Icon,
      PrimaryButton,
      WmsTextInput,
      TrashIcon,
      WmsSuggestInput,
      DentatsuMailMstModal,
      DentatsuMailMstEditModal,
    },

    // beforeSend：送信前に呼ぶ関数。false が返ったら送信しない（メインタスクの入力チェック）
    props: ['mail', 'referenceMode', 'requestPost', 'beforeSend'],
  
    computed: {
    },
  
    data() {
      return {
        reload: 0,
        // メールマスタ編集モーダル
        openMailMst: false,
        editModalShow: false,
        // マスタに保存したいメール
        newData: null,
        // メールリスト
        mailList: [],
        // CC、BCCリスト
        ccList: [],
        // 送信中
        sending: false
      }
    },

    created() {
      this.getMailList()
      this.getCCList()
    },
  
    methods: {
      /**
       * 協力会社メール取得
       */
      async getMailList() {
        this.mailList = []

        let pic = {}
        // 協力会社のメール取得
        const res = await backend.searchData('mail/getData', { type: 2 })
        if (res.data.data.length) {
          // 成型
          let list = {}

          for (let i = 0; i < res.data.data.length; i++) {
            const r = res.data.data[i]
            if (!list[r.company]) {
              list[r.company] = []
              pic[r.company] = []
            }
            list[r.company].push({ name: r.name, mail: r.mail })
            pic[r.company].push(r.name)
          }

          for (let i = 0; i < Object.keys(list).length; i++) {
            const company = Object.keys(list)[i]
            const row = list[company]
            this.mailList.push({ company: company, detail: row, pic: pic[company].join('、') })
          }
        }
      },

      /**
       * デンタツCC,BCCリスト取得
       */
      getCCList() {
        // 社員のメールアドレス取得
        const cc = this.$store.getters.userList.map(function(item) {
          return {
            name: utils.deleteKana(item.user_name),
            mail: item.e_mail_adress
          }
        })
        this.ccList = cc.filter((c) => {
          return c.name != '未定' && c.mail.indexOf('apollo-kanzai.co.jp') > -1
        })
      },
      /**
       * 送信先追加
       */
      mailAdd() {
        this.mail.to.push('')
        this.reload++
      },

      /**
       * 送信先削除
       */
      mailDelete(i) {
        this.mail.to.splice(i, 1)
        if (!this.mail.to || !this.mail.to.length) {
          this.mailAdd()
        }
        this.reload++
      },

      /**
       * CC追加
       */
      ccAdd() {
        this.mail.cc.push('')
        this.reload++
      },

      /**
       * CC削除
       */
      ccDelete(i) {
        this.mail.cc.splice(i, 1)
        if (!this.mail.cc || !this.mail.cc.length) {
          this.ccAdd()
        }
        this.reload++
      },
      /**
       * BCC追加
       */
      bccAdd() {
        this.mail.bcc.push('')
        this.reload++
      },

      /**
       * BCC削除
       */
      bccDelete(i) {
        this.mail.bcc.splice(i, 1)
        if (!this.mail.bcc || !this.mail.bcc.length) {
          this.bccAdd()
        }
        this.reload++
      },

      /**
       * メール選択
       * @param e 選択データ
       * @param target 対象データ
       * @param i インデックス
       */
      mailSelected(e, target, i) {
        // 送信先のメアド
        if (e.company && e.detail && e.detail.length) {
          for (let idx = 0; idx < e.detail.length; idx++) {
            const d = e.detail[idx]
            const index = i + idx
            if (this.mail.to[index] || this.mail.to[index] == '') {
              this.mail.to[index] = ''
              this.mail.to[index] = d.mail
            } else {
              this.mail.to.push(d.mail)
            }
          }
        // ＣＣ、ＢＣＣ
        } else if (e.mail) {
          target[i] = e.mail
        }
        this.reload++
      },

      /**
       * 送信先メアドがマスタになければ保存
       */
      async saveMail(mail) {
        this.newData = null
        if (mail) {
          this.newData = mail
          this.editModalShow = true
        } else {
          alert('メールアドレスを入力してください。')
        }
      },

      /**
       * メールマスタモーダルClose
       */
      closeMailMstModal() {
        this.openMailMst = false
        this.getMailList()
      },

      /**
       * メールマスタ編集モーダル
       */
      closeEditModal() {
        this.editModalShow = false
        this.getMailList()
      },

      /**
       * メール送信
       */
      async sendMail() {
        // メインタスクの必須項目が足りなければ送信しない
        if (this.beforeSend && !await this.beforeSend()) {
          return
        }

        const mailTo = this.mail.to.filter((m) => {
          return m
        })

        if (!mailTo || !mailTo.length) {
          await dialogs.showErrorDialog('送信先アドレス未入力', '送信先アドレスを入力してください。')
          return
        }

        if (!this.mail.subject) {
          await dialogs.showErrorDialog('件名未入力', '件名を入力してください。')
          return
        }

        let text = []
        const m = this.mail
        if (m.user) {
          text.push('[受付者]')
          text.push(m.user)
          text.push('')
          text.push('')
        }
        if (m.date) {
          text.push('[受付日]')
          text.push(m.date)
          text.push('')
          text.push('')
        }
        if (m.time) {
          text.push('[受付時間]')
          text.push(m.time)
          text.push('')
          text.push('')
        }
        if (m.client1) {
          text.push('[社名（物件名）]')
          text.push(m.client1)
          text.push('')
          text.push('')
        }
        if (m.client2) {
          text.push('[支店]')
          text.push(m.client2)
          text.push('')
          text.push('')
        }
        if (this.requestPost.employeeName) {
          text.push('[氏名]')
          text.push(this.requestPost.employeeName)
          text.push('')
          text.push('')
        }
        if (this.requestPost.telephoneNumber) {
          text.push('[連絡先]')
          text.push(this.requestPost.telephoneNumber)
          text.push('')
          text.push('')
        }
        if (this.requestPost.inquiry_title) {
          text.push('[依頼内容]')
          text.push(this.requestPost.inquiry_title)
          text.push('')
          text.push('')
        }

        if (!text || !text.length) {
          await dialogs.showErrorDialog('本文未入力', '本文が何もない状態です。')
          return
        }

        this.$emit('sendingStart')
        this.sending = true

        const param = {
          to: mailTo,
          cc: this.mail.cc,
          bcc: this.mail.bcc,
          subject: this.mail.subject,
          text: text.join('\r\n') + '※担当者にも同じ内容を送っています。',
        }

        let msg = '送信成功'

        try {
          await backend.postData('dentatsu/sendmail', param)
        } catch (error) {
          msg = 'エラーのため送信失敗'
        }
        // console.log(result)

        if (msg) {
          if (!this.requestPost.mailResult) {
            this.requestPost.mailResult = []
          }
          this.requestPost.mailResult.push('【' + msg + '】 ' + moment().format('YYYY-MM-DD HH:mm') + '　送信先：' + mailTo.join('、')+ ' （送信者：' + utils.deleteKana(this.$store.getters.user.user_name) + '）' )
          if (msg.indexOf('成功') > -1) {
            this.sending = false
            const mail = `【${this.mail.subject}】\n送信先：${mailTo.join('\n　　　　')}\n\n${text.join('\n').replace(/\n\n/g, '\n')}\n` + '●送信者：' + utils.deleteKana(this.$store.getters.user.user_name)
            console.log(mail)
            this.$emit('sendmailRes', true, mail)
          } else {
            this.sending = false
            this.$emit('sendmailRes', false)
            await dialogs.showErrorDialog(msg, '送信できませんでした。')
          }
        }
      },

      changeReload() {
        this.reload++
      }
    }
  }
  </script>

<style scoped>
/* 入力欄を自動調整 */
textarea {
  field-sizing: content;
}
</style>